import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminFetch } from "@/lib/adminApi";

const API = process.env.REACT_APP_BACKEND_URL;

const TestModeContext = createContext({
  testMode: false,
  loading: true,
  toggle: async () => {},
  refresh: async () => {},
});

export function TestModeProvider({ children }) {
  const [testMode, setTestMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await adminFetch(`${API}/api/settings`);
      if (res.ok) {
        const d = await res.json();
        setTestMode(!!d.test_mode);
      }
    } catch {
      /* ignore transient errors — banner just won't flip */
    } finally {
      setLoading(false);
    }
  }, []);

  const toggle = useCallback(async (next) => {
    const val = typeof next === "boolean" ? next : !testMode;
    // Optimistic update so the toggle feels instant
    setTestMode(val);
    try {
      const res = await adminFetch(`${API}/api/settings`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ test_mode: val }),
      });
      if (res.ok) {
        const d = await res.json();
        setTestMode(!!d.test_mode);
      } else {
        // Revert on failure
        setTestMode(!val);
      }
    } catch {
      setTestMode(!val);
    }
  }, [testMode]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <TestModeContext.Provider value={{ testMode, loading, toggle, refresh }}>
      {children}
    </TestModeContext.Provider>
  );
}

export function useTestMode() {
  return useContext(TestModeContext);
}
